import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams'
import { ICryptoCurrency, ICurrency } from '../../../api/types'
import { currenciesApi } from '../../../api'
import { GET_CRYPTO_CURRENCIES } from '../../../api/constants'

export const useCryptoCurrencies = () => {
  const { data, isLoading } = useCustomQueryWithParams([GET_CRYPTO_CURRENCIES], () =>
    currenciesApi.getCryptoCurrencies()
  )
  const currencies = data?.data ?? []

  const baseCurrencies: ICurrency[] = []
  const cryptoCurrencies: ICryptoCurrency[] = []

  currencies.forEach(currency => {
    if (currency.crypto) {
      cryptoCurrencies.push(currency)
    } else {
      baseCurrencies.push(currency)
    }
  })

  return {
    baseCurrencies,
    cryptoCurrencies,
    isLoading,
  }
}
